import { Button, notification } from 'antd';

import { ARTIST_STATUS } from 'shared/constants/app';
import React from 'react';
import birthDeathTypes from '../../../../src/utils/birth-death-types';
import copyToClipboard from 'shared/tools/copy-to-clipboard';
import { getAuthorUrl, searchAuthorAllLotsURL, searchAuthorPublishedLotsURL } from 'shared/tools/url';

export const ARTIST_TABLE_COLUMNS = [
  {
    title: 'ID',
    key: 'id',
    dataIndex: 'id',
    sorter: true,
    render: (value, row) =>
      row.is_hidden ? (
        <div style={{ textAlign: 'center' }}>
          <div>{value}</div>
          <Button
            size="small"
            onClick={() => {
              copyToClipboard(value);

              notification.success({
                message: 'Copy to clipboard',
                description: 'Artist Id has been copied.',
              });
            }}
            type="primary"
          >
            Copy Id
          </Button>
        </div>
      ) : (
        <div style={{ textAlign: 'center' }}>
          <div>
            <a href={getAuthorUrl(value)} target="_blank" rel="noopener noreferrer">
              {value}
            </a>
          </div>

          <Button
            size="small"
            onClick={() => {
              copyToClipboard(value);

              notification.success({
                message: 'Copy to clipboard',
                description: 'Artist Id has been copied.',
              });
            }}
            type="primary"
          >
            Copy Id
          </Button>
        </div>
      ),
    fixed: true,
    width: 110,
  },
  {
    title: 'Name',
    key: 'name',
    dataIndex: 'name',
    sorter: true,
    render: (value, row) =>
      row.is_hidden ? (
        value
      ) : (
        <a href={getAuthorUrl(row.id)} target="_blank" rel="noopener noreferrer">
          {value}
        </a>
      ),
    width: 400,
    fixed: true,
  },

  {
    title: 'First Name',
    key: 'first_name',
    dataIndex: 'first_name',
    sorter: true,
    render: (value) => {
      return <div>{value}</div>;
    },
    width: 400,
    fixed: true,
  },
  {
    title: 'Surname',
    key: 'surname',
    dataIndex: 'surname',
    sorter: true,
    render: (value) => {
      return <div>{value}</div>;
    },
    width: 400,
    fixed: true,
  },
  {
    title: 'Moniker',
    key: 'moniker',
    dataIndex: 'moniker',
    sorter: true,
    render: (value) => {
      return <div>{value}</div>;
    },
    width: 400,
    fixed: true,
  },
  {
    title: 'Nationality',
    key: 'nationality',
    dataIndex: 'nationality',
    sorter: false,
    width: 150,
  },
  {
    title: 'Birth / Established',
    key: 'birth',
    dataIndex: 'birth',
    sorter: true,
    width: 100,
  },
  {
    title: 'Death',
    key: 'death',
    dataIndex: 'death',
    sorter: true,
    width: 100,
  },
  {
    title: 'Status',
    key: 'artist_status',
    dataIndex: 'artist_status',
    sorter: true,
    width: 140,
    render: (value) => {
      const isPending = value === ARTIST_STATUS.PENDING;

      return <div style={{ color: isPending ? 'red' : '' }}>{value}</div>;
    },
  },
];
